import { takeLatest, call, put, select } from 'redux-saga/effects';
import axios from 'axios';
import { turnitinRequest, turnitinFailure, turnitinSuccess, turnitinDoSubmissionRequest, turnitinGetEulaRequest } from '../reducers/turnitin';

import { API_LINK } from '../../constants';
import moment from 'moment';

const API = `${API_LINK}api`;




function* turnitinRequestFunctionAxios() {
  const state = yield select(fullState => fullState);
  const {
    user,
    token,
  } = state.loginReducer;

  const {
    request_id,
    selectedContent
  } = state.turnitinReducer;


  const { assessmentContent } = state.userProgramsFullReducer;

  var data = JSON.stringify({
    "owner": user.userId,
    "title": assessmentContent.name,
    "owner_default_permission_set": "LEARNER",
    "metadata": {
      "owners": [
        {
          "id": user.userId,
          "given_name": user.firstName,
          "family_name": user.lastName,
          "email": user.email
        }
      ],
      "original_submitted_time": moment().format('YYYY-MM-DDTHH:mm:ss').toString()+'Z',
      "custom": "{\"Type\":\"Free Text\", \"request_id\":\""+request_id+"\", \"user_id\":\""+user.userId+"\"}"
    }
  });

  const response = yield call(() =>
    axios({
      method: 'post',
      url: API+'/assessor/tii_requestSubmission',
      headers: {
        'Access-Control-Allow-Origin': '*',
        'Content-Type': 'application/json',
        'X-Requested-With': 'XMLHttpRequest',
        Authorization: `Bearer ${token}`,
      },
      credentials: 'same-origin',
      data: {
        tii_data: data
      },
    }),
  );

  return response;
}

function* workerTurnitinRequestSaga() {
  try {
    const response = yield call(turnitinRequestFunctionAxios);
    const responseFromTurnitinRequest = response.data;
    if (response.status === 200) {
      if(responseFromTurnitinRequest.success==false){
        yield put(turnitinGetEulaRequest());
      }else{
        yield put(turnitinSuccess(responseFromTurnitinRequest));
        yield put(turnitinDoSubmissionRequest())
      }
    }
    if (response.status === 201) {
      yield put(turnitinFailure(responseFromTurnitinRequest.message));
    }
  } catch (error) {
    yield put(turnitinFailure(error.message));
  }
}

export function* watcherTurnitinRequestSaga() {
  yield takeLatest(turnitinRequest().type, workerTurnitinRequestSaga);
}
